import React from 'react';
import classNames from 'classnames';
import { IUserContext, withUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import {
  isExperimentEnabled,
} from '@reverbdotcom/commons/src/user_context_helpers';
import { trackEvent, MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/src/elog/mparticle';
import experiments from '@reverbdotcom/commons/src/experiments';
import useDismissibleAlert from '@reverbdotcom/commons/src/components/use_dismissible_alert';
import { Paths } from './shared/url_helpers';
import { withPrefix } from '@reverbdotcom/commons/src/i18n_helpers';

const t = withPrefix('discovery.appInstallCallout');
const ACTION_CLOSE = 'close';
const ACTION_INSTALL = 'install';
const COMPONENT_NAME = 'AppInstallCallout';
const DISMISSABLE_KEY = 'app_install_callout';

interface IProps {
  calloutLocation: 'csp' | 'item' | 'homepage' | 'watchlist' | 'feed' | 'sell';
  canonicalUrl?: string;
}

export function AppInstallCallout(props: IProps & IUserContext) {
  const [dismissed, dismiss] = useDismissibleAlert(DISMISSABLE_KEY);
  const closeModal = (action) => {
    dismiss();

    trackEvent({
      componentName: COMPONENT_NAME,
      eventName: MParticleEventName.ClickedComponent,
      experiments: formatExperimentsForEventAttributes(props.user, [
        experiments.APP_INSTALL_CALLOUT,
      ]),
      interactionType: action,
    });
  };

  const renderCta = () => {
    return (
      <a
        className="button width-100"
        href={Paths.mobileAppsLanding.expand({})}
        rel="noopener noreferrer nofollow"
        onClick={() => closeModal(ACTION_INSTALL)}
      >
        {t('cta')}
      </a>
    );
  };

  React.useEffect(() => {
    if (dismissed) return;
    trackEvent({
      componentName: COMPONENT_NAME,
      eventName: MParticleEventName.ComponentView,
      experiments: formatExperimentsForEventAttributes(props.user, [
        experiments.APP_INSTALL_CALLOUT,
      ]),
    });
  }, [dismissed]);

  if (dismissed) return null;
  if (!isExperimentEnabled(props.user, experiments.APP_INSTALL_CALLOUT)) return null;

  const classes = classNames(
    'app-install-callout',
    { 'app-install-callout--open': !dismissed },
  );

  return (
    <div className={classes}>
      <div className="weight-bold size-120">
        {t(`${props.calloutLocation}.title`)}
      </div>
      <div className="mb-1 size-90">
        {t(`${props.calloutLocation}.subtitle`)}
      </div>
      {renderCta()}
      <button
        type="button"
        className="app-install-callout__close"
        onClick={() => closeModal(ACTION_CLOSE)}
        aria-label={t('close')}
      />
    </div>
  );
}

export default withUserContext(AppInstallCallout);
